import { render, staticRenderFns } from "./QualityMeasuresPage.vue?vue&type=template&id=0ffd9ed0&"
import script from "./QualityMeasuresPage.vue?vue&type=script&lang=js&"
export * from "./QualityMeasuresPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports